import $ from 'jquery';
import Swiper from 'swiper';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import 'heightline/jquery.heightLine.js';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

// ハンバーガーメニュのアニメーション
const spMenuAnime = () => {
  $('#hamuButton').on('click', function () {
    if ($('.hamu-menu').hasClass('is_set')) {
      $('.hamu-menu').removeClass('is_set');
      $('.sp-menu').removeClass('is_set');
    } else {
      $('.hamu-menu').addClass('is_set');
      $('.sp-menu').addClass('is_set');
    }
  })
}

// ps時のfooterメニューの高さを取得してbodyタグにmargin-bottmを付与する
const bottomMargin = () => {
  $(window).on('load resize', function () {
    let spMenuHeight = $('.sp-bottom-menu').innerHeight();
    $('body').css('margin-bottom', spMenuHeight)
  })
}

// pdfファイルのリンクを別タブで開くように
const tergetPdf = () => {
  $('.contentsPdf').attr('target', '_blank');
}

// ここからアニメーションスクリプト
const walkAnime01 = (footContent01, walkArea) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: walkArea,
      start: 'top 80%',
      once: false,
      // end: "center 25%",
    },
  });
  tl.to(footContent01, {
    duration: .8,
    x: 0,
    y: 0,
    width: 20,
    autoAlpha: 1,
    ease: 'circ.out',
    overwrite: 'auto',
  }).to(footContent01, {
    delay: 2,
    opacity: 0
  })
}

const walkAnime02 = (footContent02, walkArea) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: walkArea,
      start: 'top 80%',
      once: false,
      // end: "center 25%",
    },
  });
  tl.to(footContent02, {
    duration: 1.6,
    delay: .8,
    x: 0,
    y: 0,
    width: 20,
    autoAlpha: 1,
    ease: 'circ.out',
    overwrite: 'auto',
  }).to(footContent02, {
    delay: 2,
    opacity: 0
  })
}

const walkAnime03 = (footContent03, walkArea) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: walkArea,
      start: 'top 80%',
      once: false,
      // end: "center 25%",
    },
  });
  tl.to(footContent03, {
    duration: 2.4,
    delay: 1.6,
    x: 0,
    y: 0,
    width: 20,
    autoAlpha: 1,
    ease: 'circ.out',
    overwrite: 'auto',
  }).to(footContent03, {
    delay: 2,
    opacity: 0
  })
}

const walkAnime04 = (footContent04, walkArea) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: walkArea,
      start: 'top 80%',
      once: false,
      // end: "center 25%",
    },
  });
  tl.to(footContent04, {
    duration: 3.2,
    delay: 2.4,
    x: 0,
    y: 0,
    width: 20,
    autoAlpha: 1,
    ease: 'circ.out',
    overwrite: 'auto',
  })
    .to(footContent04, {
      delay: 2,
      opacity: 0
    })
}

const flowerAnime01 = (hana01, walkArea) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: walkArea,
      start: 'top 80%',
      once: false,
      // end: "center 25%",
    },
  });
  tl
    .to(hana01, {
      delay: .5,
      duration: 1.5,
      width: 36,
      autoAlpha: 1,
      rotate: 230,
      ease: 'circ.out',
      overwrite: 'auto',
    })
    .to(hana01, {
      delay: 4,
      opacity: 0
    })
}

const flowerAnime02 = (hana02, walkArea) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: walkArea,
      start: 'top 80%',
      once: false,
      // end: "center 25%",
    },
  });
  tl
    .to(hana02, {
      duration: 1.5,
      delay: 1.0,
      width: 23,
      autoAlpha: 1,
      rotate: -230,
      ease: 'circ.out',
      overwrite: 'auto',
    })
    .to(hana02, {
      delay: 4,
      opacity: 0
    })
}

const flowerAnime03 = (hana03, walkArea) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: walkArea,
      start: 'top 80%',
      once: false,
      // end: "center 25%",
    },
  });
  tl
    .to(hana03, {
      duration: 1.5,
      delay: 1.5,
      rotate: 230,
      ease: 'circ.out',
      overwrite: 'auto',
      opacity: 1,
      width: 20
    }).to(hana03, {
      delay: 4,
      opacity: 0
    })
}

const animeScrollTrigger = () => {
  gsap.utils.toArray('.walk-area').forEach((walkArea, index) => {

    const footContent01 = walkArea.querySelector('.footContent-01');
    const footContent02 = walkArea.querySelector('.footContent-02');
    const footContent03 = walkArea.querySelector('.footContent-03');
    const footContent04 = walkArea.querySelector('.footContent-04');
    const hana01 = walkArea.querySelector('.flower-01');
    const hana02 = walkArea.querySelector('.flower-02');
    const hana03 = walkArea.querySelector('.flower-03');

    // Do the parallax effect on each section
    walkAnime01(footContent01, walkArea);
    walkAnime02(footContent02, walkArea);
    walkAnime03(footContent03, walkArea);
    walkAnime04(footContent04, walkArea);
    flowerAnime01(hana01, walkArea);
    flowerAnime02(hana02, walkArea);
    flowerAnime03(hana03, walkArea);
  });
};

// CVボタンをFVが画面からいなくなったらつける
const lpCvButtomScripts = () => {
  $(window).on('scroll resize load', () => {
    const cvButton = $('#lpCvButton');
    const mainVisual = $('#lpMv');
    let scrollPosition = $(window).scrollTop();
    let buttonHeight = cvButton.innerHeight();
    let mainVisualHeight = mainVisual.innerHeight();
    cvButton.css('bottom', '-' + buttonHeight + 'px');

    if (scrollPosition > mainVisualHeight) {
      cvButton.css('bottom', '0px');
      $('body').css('margin-bottom', buttonHeight)
    } else {
      cvButton.css('bottom', '-' + buttonHeight + 'px');
      $('body').css('margin-bottom', 0)
    };
  });
}

// 仮登録ページへのリンクを持つ要素をパーマリンクを削除してd-noneする
const registrBtnRemove = () => {
  const registrBtn = document.querySelectorAll('a');
  const registrBtnArr = Array.prototype.slice.call(registrBtn);
  let btnHref;

  const nowDate = new Date();
  let endDate = '2021/10/14 00:00';
  endDate = new Date(endDate);

  if (!(endDate <= nowDate)) {
    registrBtnArr.forEach((btn) => {
      btnHref = btn.getAttribute('href');
      if (btnHref.match(/provisional-registration/) || btnHref.match(/sp\/matching/)) {
        btn.classList.add("d-none");
        btn.removeAttribute('href');
      }
    })
  }
}

const agreeCheck = () => {
  // アラートのglobal変数
  const alertText = '利用規約、みやざき結婚サポートセンター会員規約、みやざき結婚サポートセンター利用規定をご確認の上、チェックボックスにご同意ください。';
  // 仮登録ページ
  const registraBtn = document.getElementById('registraBtn');
  const agreeCheckList = document.querySelectorAll('.agree');
  // LP上部
  const registraBtnHead = document.getElementById('registraBtnHead');
  const agreeCheckHead = document.getElementById('agreeHead');
  // LP下部
  const registraBtnFoot = document.getElementById('registraBtnFoot');
  const agreeCheckFoot = document.getElementById('agreeFoot');

  if (registraBtn) {
    registraBtn.addEventListener('click', (ev) => {
      let allChecked = true;
      agreeCheckList.forEach((checkbox) => {
        if (!checkbox.checked) {
          allChecked = false;
        }
      });
      if (allChecked) {

      } else {
        alert(alertText);
        ev.preventDefault();
      }
    });
  }
  // if (registraBtnHead) {
  //   registraBtnHead.addEventListener('click', (ev) => {
  //     if (agreeCheckHead.checked) {

  //     } else {
  //       alert(alertText);
  //       ev.preventDefault();
  //     }
  //   })
  // }

  // if (registraBtnFoot) {
  //   registraBtnFoot.addEventListener('click', (ev) => {
  //     if (agreeCheckFoot.checked) {

  //     } else {
  //       alert(alertText);
  //       ev.preventDefault();
  //     }
  //   })
  // }
}


//lpスライダー
const lpSlider = () => {
  const swiper = new Swiper('.lp-slider', {
    loop: true,
    effect: 'fade',
    speed: 2000,
    slidesPerView: 1,
    centeredSlides: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}


window.addEventListener('load', () => {
  lpSlider();
});

$(() => {
  spMenuAnime();
  bottomMargin();
  tergetPdf();
  animeScrollTrigger();
  lpCvButtomScripts();
  agreeCheck();

});

// ↓↓↓↓↓↓これを10/14 00:00 以降にコメントアウトしてくださーい
document.addEventListener('DOMContentLoaded', () => {
  // registrBtnRemove();
});
// ↑↑↑↑↑↑これを10/14 00:00 以降にコメントアウトしてくださーい

// lpのheightLine調整
$(window).on('load', () => {
  $(".lp-point-items").heightLine({
    minWidth: 768
  });
  $(".voiceHeight").heightLine({
    minWidth: 768
  });
  $(".coupleHeight").heightLine({
    minWidth: 768
  });
  $(".staffHeight").heightLine({
    minWidth: 768
  });
});
